import { render, staticRenderFns } from "./OnboardMethod.vue?vue&type=template&id=47ebf85c&"
import script from "./OnboardMethod.vue?vue&type=script&lang=js&"
export * from "./OnboardMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports